import { unstable_batchedUpdates } from 'react-dom';
import Alt from 'alt';

// Enable batch updates to avoid multiple dispatch errors
// Context: https://github.com/goatslacker/alt/pull/278
const alt = new Alt({ batchingFunction: unstable_batchedUpdates });

// Uncomment this to debug using alt devtool https://github.com/goatslacker/alt-devtool
// Alt.debug("alt", alt);

export default alt;
